/**
 * TP-502: brief hold of the classic progressive email step for sellers so
 * Mida's B redirect to `/signup-ari` can win before the email UI paints.
 *
 * During the hold the role step stays on screen (selected seller, full cards) —
 * no email-form skeleton or spinner. Option A architecture unchanged —
 * no mida.execute / in-app navigate. Fail-open: after the timeout, email
 * shows as today (variant A / blocked Mida).
 */

/** Hold budget (ms). Midpoint of 300–500ms; QA if Mida redirect is slower. */
export const SELLER_EMAIL_HOLD_MS = 400;

/**
 * Whether the progressive signup email form should mount.
 * Sellers while `sellerEmailHold` is true stay hidden; buyers are never held.
 *
 * @param {{
 *   step: number,
 *   accountType: string,
 *   sellerEmailHold: boolean,
 * }} args
 * @returns {boolean}
 */
export function shouldShowSignupEmailStep({
  step,
  accountType,
  sellerEmailHold,
}) {
  if (step !== 2 || !accountType) {
    return false;
  }
  if (accountType === 'seller' && sellerEmailHold) {
    return false;
  }
  return true;
}
